import { RoutingMap } from '@app/entities';
import { Link, useParams } from 'react-router-dom';
import Styles from './Styles.module.scss';
import type { MenuProps } from 'antd';
type ItemType = NonNullable<MenuProps['items']>[number];
import { getLocationSubdomain } from '@common/utils';

export default function FooterSection() {
    const subdomain = getLocationSubdomain();
    const { name } = useParams();

    if (subdomain || name)
        return (
            <div className="fixed bottom-0 left-0 p-2 bg-white z-10000">
                <div className={Styles.TextWrapper}>
                    <span>&copy;ModelPark 2024 </span>
                    <span> | All Rights Reserved</span>
                </div>
            </div>
        );
    return (
        <div className={Styles.Footer}>
            <div className={Styles.LogoSection}>
                <img
                    src="/logo.svg"
                    alt="logo"
                    className={Styles.Logo}
                />
                <div className={Styles.TextWrapper}>
                    <span>&copy;ModelPark 2024 </span>
                    <span> | All Rights Reserved</span>
                </div>
            </div>
            <div className={Styles.LinkSection}>
                {MenuItems.map(item => (
                    <Link
                        to={item.key}
                        className={Styles.Link}
                        key={item.key}
                    >
                        {item.label}
                    </Link>
                ))}
            </div>
        </div>
    );
}
const MenuItems: MenuItemType[] = [
    {
        key: RoutingMap.Home,
        label: 'Apps',
        title: 'Home',
    },
    {
        key: RoutingMap.NewProject,
        label: 'New Project',
        title: 'New Project',
    },
    {
        key: RoutingMap.Cli,
        label: 'CLI',
        title: 'CLI',
    },
    {
        key: RoutingMap.Analytcis,
        label: 'Analytics',
        title: 'Analytics',
    },
    {
        key: RoutingMap.About,
        label: 'About',
        title: 'About',
    },
    {
        key: RoutingMap.Settings.Profile,
        label: 'Settings',
        title: 'Settings',
    },
    {
        key: RoutingMap.LegalClaimer,
        label: 'Legal Disclaimer ',
        title: 'Legal Disclaimer',
    },
];

type MenuItemType = ItemType & { key: string; label?: string };
